"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCreditCardFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M22 8H2V6c0-1.333.667-2 2-2h16c1.333 0 2 .667 2 2v2zm0 3v7c0 1.338-.667 2.005-2 2H4c-1.333.005-2-.662-2-2v-7h20zM9 14c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h5c.667 0 1-.333 1-.999 0-.666-.333-.999-1-.999H9zm-4 0c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h1c.667 0 1-.333 1-.999C7 14.333 6.667 14 6 14H5z' }))); };
exports.default = SvgCreditCardFilled;
//# sourceMappingURL=CreditCardFilled.js.map